import React from "react";
import { EntityType } from "@/services/hooks/entities/useEntityType";
import Ownership from "@/components/layouts/Ownership";
import { CompanyData } from "@/pages/companies/types";
import CompanyTopFields from "@/pages/companies/components/CompanyTopFields";
import CompanyDetailFields from "@/pages/companies/components/CompanyDetailFields/CompanyDetailFields";
import InvolvedIn from "@/components/layouts/InvolvedIn";
import PeopleSection from "@/components/layouts/QuickView/PeopleSection/PeopleSection";
import { DetailedViewOptions } from "@/components/controls/OptionsDropdownMenu/OptionsDropdownMenu";
import NextSteps from "@/components/layouts/NextSteps/NextSteps";
import CompanyKPIs from "@/pages/companies/components/CompanyKPIs";

interface Props {
  company: CompanyData | undefined;
  onUpdateCompanyField: (
    field: string,
    newValue: string | number,
    additionalFields?: {
      [fieldName: string]: string | number;
    }
  ) => void;
  isDrawerOpen: boolean;
  getCreateOptions: () => DetailedViewOptions;
}

const CompanyQuickViewContent: React.FC<Props> = ({
  company,
  onUpdateCompanyField,
  isDrawerOpen,
  getCreateOptions
}) => {
  const createOptions = getCreateOptions();

  const getActionFunction = (option: any) => {
    return typeof option === "function" ? option : option?.action;
  };

  return (
    <div className="flex flex-col gap-4 w-full">
      <CompanyTopFields
        className="flex-wrap gap-0 pl-5 pr-0"
        company={company}
        onUpdateField={onUpdateCompanyField}
      />
      <div className="flex flex-col w-full gap-4 pl-5">
        <CompanyKPIs
          company={company}
          containerClassName="grid-cols-[repeat(auto-fill,minmax(12rem,12rem))]"
          isQuickView
        />
        <CompanyDetailFields
          className="w-full px-4 min-h-fit"
          company={company}
          onUpdateField={(
            field: string,
            newValue: string | number | string[]
          ) => onUpdateCompanyField(field, newValue as string | number)}
          isDrawerOpen={isDrawerOpen}
          isQuickView
        />
        <PeopleSection company={company} />
        <InvolvedIn
          entityId={company?.id || ""}
          entityType={EntityType.COMPANY}
          className="min-h-fit"
          isQuickView
          onCreateLead={getActionFunction(createOptions.lead)}
          onCreateDeal={getActionFunction(createOptions.deal)}
          onCreateContract={getActionFunction(createOptions.contract)}
        />
        <NextSteps
          className="w-full px-4"
          entity={company}
          entityType={EntityType.COMPANY}
          isQuickView
        />
        <Ownership
          entity={company}
          entityType={EntityType.COMPANY}
          onUpdateField={onUpdateCompanyField}
          isQuickView
        />
      </div>
    </div>
  );
};

export default CompanyQuickViewContent;
